
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {Kultur} from './kultur';


@Injectable()
export class KUService {

  constructor(private httpService: HttpClient) { }

error;
  getKultur():Observable<Kultur[]> {

    // in dist muss bilgar mit in Pfad rein '../bilgar/assets/kultur-tagschichten.json'
    return this.httpService.get<Kultur[]>('../assets/kultur-tagschichten.json')
    .pipe(
      tap(_ => this.log('fetched kultur')),
      catchError(this.handleError<Kultur[]>('getKultur', []))
    );
  }



  log(ewe){
    

    
   console.log(ewe)

  }


  

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}



